<template>
  <div>
    <template v-if="!account1 && needConnect">
      <el-button class="common-btn-blue" :loading="loading" @click="connectWallet">
        Connect Wallet
      </el-button>
    </template>
    <template v-else>
      <el-button
        :loading="loading"
        class="common-btn-blue"
        :disabled="disabled"
        @click="clickHandle"
      >
        {{ label }}
      </el-button>
    </template>
  </div>
</template>

<script>
import { setToken } from '@/utils/auth'

export default {
  components: {},
  props: {
    label: {
      type: String,
      default: () => {
        return 'Submit'
      }
    },
    disabled: {
      type: Boolean
    },
    needConnect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    account1() {
      return this.$store.getters.metaMaskObj.account
    }
  },
  watch: {
    account1: {
      handler(newValue, oldValue) {
        // console.log(newValue);
        this.account = newValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getProvider() {
      return window.ethereum || null
    },
    clickHandle() {
      this.loading = true
      this.$emit('clickHandle', this)
    },
    closeLoad() {
      this.loading = false
    },
    async connectWallet() {
      try {
        const provider = this.getProvider()
        if (!provider) {
          this.$message.error('MetaMask provider is not available')
          return
        }
        this.loading = true
        // Will open the MetaMask UI
        const accounts = await provider.request({ method: 'eth_requestAccounts' })
        if (!accounts[0]) {
          this.$message.error('Not able to get accounts')
          this.loading = false
          return
        }

        this.account = accounts[0]
        this.$store.commit('app/SET_MATEMASK', {
          isConnect: true,
          account: accounts[0]
        })
        setToken(this.account)

        // 发送初始化事件，让父组件知道钱包已连接
        this.$emit('walletConnected', accounts[0])
        this.loading = false
      } catch (error) {
        console.error('Failed to connect wallet:', error)
        this.loading = false
        this.$store.commit('app/SET_MATEMASK', { isConnect: false, account: '' })
        this.$message.error(error && error.message ? error.message : 'Failed to connect wallet')
      }
    }
  }
}
</script>
<style scoped lang="scss">
.common-btn-blue {
  font-family: DMSans-Medium;
  border-radius: 0.14rem;
}
</style>
